export default __webpack_public_path__ + "static/media/courses.70ee72f5.png";